import { Component } from "@angular/core";
import { ServiceRequestComponent } from "../components/service-request/service-request.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-side-navigation-component',
  templateUrl: './side-nav-menu.component.html',
  styleUrls: ['./side-nav-menu.component.scss']
})
export class SideNavComponent{

  constructor(public readonly bsModalService:NgbModal) { }


  onServiceRequestShow() {

    this.bsModalService.open(ServiceRequestComponent, { size: 'xl', centered: true,backdrop:'static' })
  }
}
